import L from "leaflet";

export const getCurrentLocationIcon = () =>
  L.divIcon({
    html: `
    <div class="text-blue-600">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        class="w-10 h-10"
      >
        <circle cx="12" cy="12" r="8" class="fill-blue-600 opacity-20"/>
        <circle cx="12" cy="12" r="4" class="fill-blue-600"/>
        <circle cx="12" cy="12" r="2" class="fill-white"/>
      </svg>
    </div>
  `,
    className: "current-location-pin",
    iconSize: [50, 50],
    iconAnchor: [20, 20],
    popupAnchor: [0, -20],
  });

export const getClickedLocationIcon = () =>
  L.divIcon({
    html: `
    <div class="text-red-600">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        class="w-8 h-8"
      >
        <path 
          class="fill-current" 
          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
        />
      </svg>
    </div>
  `,
    className: "clicked-location-pin",
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });
